 var format = function(time, format){
  if (time == null || time == "") {
    return "";   //没有传时间就显示空白，防止默认显示1970-01-01
  }
  var t = new Date(time);
  var tf = function(i){return (i < 10 ? '0' : '') + i};
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a){
    switch(a){
               case 'yyyy':
                   return tf(t.getFullYear());
                   break;
               case 'MM':
                   return tf(t.getMonth() + 1);
                   break;
               case 'mm':
                   return tf(t.getMinutes());
                   break;
               case 'dd':
                   return tf(t.getDate());
                   break;
               case 'HH':
                   return tf(t.getHours());
                   break;
               case 'ss':
                   return tf(t.getSeconds());
                   break;
        }
   })
  }
  export {format}